export const GET_SITES_ASSET = "GET_SITES_ASSET";
export const GET_SITES_DOOR_ASSET = "GET_SITES_DOOR_ASSET";
export const GET_SITES_PAT_ASSET = "GET_SITES_PAT_ASSET";
export const GET_SITES_PFP_ASSET = "GET_SITES_PFP_ASSET";
export const ADD_SITE_ASSET = "ADD_SITE_ASSET";